// Per-component style overrides so the common properties (corner radius,
// elevation style, spacing) are set once here instead of repeated as ad hoc
// `sx` values at every call site across the app.

export default function getComponents(tokens) {
  const { radius } = tokens;

  return {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: radius.md },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          // Kills MUI's dark-mode elevation overlay gradient, which reads as
          // "Material," not flat iOS surfaces.
          backgroundImage: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: radius.lg },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: radius.lg },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: radius.pill },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: { borderRadius: radius.pill },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: { minWidth: 0 },
      },
    },
  };
}
